import { useMutation, useQuery } from "@tanstack/react-query";
import { get, post } from "../../api/client";
import queryClient from "../../config/queryClient";

export const NOTIFICATION_KEY = {
  GET_UNSEEN_NOTIFICATIONS_COUNT: "GET_UNSEEN_NOTIFICATIONS_COUNT",
};

export const useGetUnseenNotificationsCount = () => {
  return useQuery([NOTIFICATION_KEY.GET_UNSEEN_NOTIFICATIONS_COUNT], () => {
    return get({ url: "/api/v1/notification/unSeenNotification/count" });
  });
};

export const useMarkNoticationAsRead = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: Error) => unknown;
}) => {
  return useMutation(
    () => {
      return post({
        url: `/api/v1/notification/unSeenNotification/markAsSeen`,
      });
    },
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries({
          queryKey: [NOTIFICATION_KEY.GET_UNSEEN_NOTIFICATIONS_COUNT],
        });
      },
      onError: (error: Error) => {
        onError(error);
      },
    }
  );
};
